import React, { ReactNode } from 'react';
import styled from 'styled-components';
import AntdForm from 'antd/es/form';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import Button from 'antd/es/button';
import { FormListFieldData } from 'antd/es/form/FormList';

import { BaseInputProps, DescriptionFormItem, FormItem } from './shared';

interface ListInputProps extends BaseInputProps {
    childInput: (props: FormListFieldData) => ReactNode;
    addText?: string;
}
export const ListInput = ({
    name = '',
    label,
    description = '',
    rules,
    childInput,
    addText = 'Add Item',
}: ListInputProps) => {
    return (
        <AntdForm.List name={name}>
            {(fields, { add, remove }, { errors }) => (
                <>
                    <DescriptionFormItem label={label} rules={rules} description={description} />
                    {fields.map((field: FormListFieldData) => (
                        <AntdForm.Item key={field.key} noStyle>
                            <Grid>
                                <InputWrapper>{childInput(field)}</InputWrapper>
                                <div>
                                    <RemoveButton
                                        className="dynamic-delete-button"
                                        onClick={() => remove(field.name)}
                                    />
                                </div>
                            </Grid>
                        </AntdForm.Item>
                    ))}
                    <FormItem>
                        <StyledAdd type="dashed" onClick={() => add()} icon={<PlusOutlined />}>
                            {addText}
                        </StyledAdd>
                        <AntdForm.ErrorList errors={errors} />
                    </FormItem>
                </>
            )}
        </AntdForm.List>
    );
};

const StyledAdd = styled(Button)`
    width: 100%;
`;

const Grid = styled.div`
    display: grid;
    grid-template: 'input removeBtn' auto / auto max-content;
    align-items: baseline;
`;

const InputWrapper = styled.div`
    padding-right: ${({ theme }) => theme.spacing.sm};
`;

const RemoveButton = styled(MinusCircleOutlined)`
    color: ${({ theme }) => theme.color.R6};
`;
